import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private oauthService: OAuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken()) {
      return true;
    } else {
      localStorage.setItem('returnUrl', state.url);
      this.oauthService.initImplicitFlow();
      // this.router.navigate(['/home']);
    }

  }

}
